(ns bec-core.cljs.views
  (:require [reagent.core :as r]
            [re-frame.core :as rf]
            [bec-cljs-common.networking :as bcc.net]
            [bec-cljs-common.url :as bcc.url]
            [bec-core.cljs.views.layout :as layout]
            [bec-core.cljs.views.home :as home]
            [bec-core.cljs.views.selection :as selection]
            [bec-core.cljs.views.countries :as countries]
            [bec-core.cljs.views.cities :as cities]
            [bec-core.cljs.views.venues :as venues]
            [bec-core.cljs.views.machines :as machines]
            [bec-core.cljs.views.dashboard :as dashboard]
            [bec-core.cljs.views.login :as login]
            [bec-core.cljs.views.leaderboard :as leaderboard]))


(defmulti views identity)
(defmethod views :home [] [home/view])
(defmethod views :selection [_ props] [selection/view props])
(defmethod views :countries [_ props] [countries/view props])
(defmethod views :cities [_ props] [cities/view props])
(defmethod views :venues [_ props] [venues/view props])
(defmethod views :machines [_ props] [machines/view props])
(defmethod views :dashboard [] [dashboard/view])
(defmethod views :login [_ props] [login/view props])
(defmethod views :leaderboard [] [leaderboard/view])


(defmethod views :waiting []
  (let [backend-connected? @(rf/subscribe [::bcc.net/sse-connected?])]
    [:div.container.is-fluid.fade-in
     [:div.section
      [:p.title "Waiting..."]
      [:p.title "Other components are starting up."]
      (if backend-connected?
        [:p.subtitle "Connected to server! Waiting for initial message"]
        [:p.subtitle "Not connected to server yet."])]]))


(defmethod views :default []
  [:div.container
   [:p.title "NOT FOUND: Undefined view key given"]])


(defn main []
  (let [[active-view props] @(rf/subscribe [:active-view])]
    (when-not (= :waiting active-view)
      (bcc.url/sync!))
    [layout/default
     [views active-view props]]))
